import { Box, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

function NewsFilterToggle({ filter, onFilterChange, newAnnouncementsCount }) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box sx={{ px: { xs: 2, sm: 3 }, mb: { xs: 2, sm: 3 } }}>
      <ToggleButtonGroup
        value={filter}
        exclusive
        onChange={(e, newValue) => newValue && onFilterChange(newValue)}
        sx={{
          backgroundColor: "background.paper",
          borderRadius: 2,
          boxShadow: theme.shadows[2],
          border: "1px solid",
          borderColor: "divider",
          "& .MuiToggleButton-root": {
            border: "none",
            borderRadius: 2,
            px: 3,
            py: 1.5,
            fontWeight: 600,
            textTransform: "none",
            "&.Mui-selected": {
              backgroundColor: alpha(theme.palette.primary.main, 0.15),
              color: theme.palette.primary.main,
              "&:hover": {
                backgroundColor: alpha(theme.palette.primary.main, 0.2),
              },
            },
            "&:hover": {
              backgroundColor: alpha(theme.palette.action.hover, 0.5),
            },
          },
        }}
        aria-label={t("news.filterAria")}
      >
        <ToggleButton value="all" aria-label={t("news.filterAllAria")}>
          {t("news.filterAll")}
        </ToggleButton>
        <ToggleButton value="new" aria-label={t("news.filterNewAria")}>
          {t("news.filterNew")} ({newAnnouncementsCount})
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

NewsFilterToggle.propTypes = {
  filter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  newAnnouncementsCount: PropTypes.number.isRequired,
};

export default NewsFilterToggle;
